import { useEffect } from 'react';
import { useSelector } from '@lingoda/hooks';
import { sectionLocaleSelector } from '@lingoda/auth';

// Hook used to lazy load translations for the chosen by user section
// in case we need to translate different language than the page language.
export const useLazyLoadSectionTranslations = () => {
    const sectionLocale = useSelector(sectionLocaleSelector);

    useEffect(() => {
        if (sectionLocale) {
            // import translations additions only to prevent side effects like setting up lang for e.g. date-fns
            void import(`@lingoda/translations/${sectionLocale}`);
        }
    }, [sectionLocale]);
};
